import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "info-box" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_4 = { class: "info-box" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_6 = { class: "info-box" }
const _hoisted_7 = { class: "info-box w-100" }

import { MintStatus } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'MintCountdown',
  props: ['time', 'status'],
  setup(__props) {

const props = __props


const mintStatus = MintStatus;

return (_ctx: any,_cache: any) => {
  const _component_VueCountdown = _resolveComponent("VueCountdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    (
        !(
          props.status === _unref(mintStatus).LIVE ||
          props.status === _unref(mintStatus).COMPLETED
        )
      )
      ? (_openBlock(), _createBlock(_component_VueCountdown, {
          key: 0,
          time: props.time
        }, {
          default: _withCtx(({ days, hours, minutes }) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(days), 1),
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, _toDisplayString(hours), 1),
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(minutes), 1)
            ])
          ]),
          _: 1
        }, 8, ["time"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, _toDisplayString(props.status), 1)
  ]))
}
}

})